/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AdhocInMeetingType } from './adhocInMeetingType';
import type { EntityHint } from './entityHint';

export interface AdhocIn {
  /** @maxLength 2048 */
  meeting_url: string;
  entity_hint?: EntityHint | null;
  project_id?: string | null;
  title?: string | null;
  meeting_type?: AdhocInMeetingType;
}
